import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import DrawerSimple from "ds/components/DrawerNew/Simple";

import RolesInfoDrawerContent from "./Content";

const RolesInfoDrawer = createDrawer(() => {
  return (
    <DrawerSimple>
      <RolesInfoDrawerContent />
    </DrawerSimple>
  );
});

export const showRolesInfoDrawer = createDrawerTrigger(RolesInfoDrawer);
